import React from "react";
import PropTypes from "prop-types";
import ConnectionAvatars from "shared/components/ConnectionAvatars";
import Composer from "apps/messenger/components/MainWindow/Composer";
import Toolbar from "apps/messenger/components/MainWindow/Toolbar";
import { WINDOW_STATE } from "apps/messenger/util/consts";
import _str from "shared/util/_str";

import ViewContainer from "apps/messenger/components/Connections/shared/ViewContainer";
import Header from "apps/messenger/components/Connections/shared/Header";
import useSmsWall from "apps/messenger/hooks/useSmsWall";

import "apps/messenger/components/Connections/Postmatch/BaseIntro.scss";

function BaseIntro({
	onClose,
	header,
	subtitle,
	targetUser,
	myThumb,
	children,
	onMessageEdit,
	sendMessage,
	draft,
}) {
	const {
		showPhoneWall,
		openPhoneVerification,
	} = useSmsWall();
	const sendDisabled = !draft.trim().length;
	const theirThumb = targetUser.thumbs[0]["225x225"];

	const theyLikedWhileBoosted = !!(
		targetUser.likes &&
		targetUser.likes.via_spotlight
	);

	const displayname = targetUser.userinfo && targetUser.userinfo.displayname;

	return (
		<div className="postmatch-intro-edit-view-scaffold">
			<ViewContainer onClose={onClose}>
				<div className="postmatch-intro-edit-view-scaffold-avatars">
					<ConnectionAvatars
						myThumb={myThumb}
						theirThumb={theirThumb}
						theirUsername={displayname}
						theyLikedWhileBoosted={theyLikedWhileBoosted}
					/>
				</div>
				<Header>{header}</Header>
				{subtitle && <Header>{subtitle}</Header>}
				<div className="postmatch-intro-edit-view-scaffold-content">
					{children}
				</div>
			</ViewContainer>
			<Composer
				userid={targetUser.userid}
				state={WINDOW_STATE.Open}
				onTextChange={onMessageEdit}
				sendDisabled={sendDisabled}
				sendMessage={sendMessage}
				text={draft}
				showPhoneWall={showPhoneWall}
				launchPhoneFlow={openPhoneVerification}
			/>
			<Toolbar
				userid={targetUser.userid}
				sendDisabled={sendDisabled}
				sendMessage={sendMessage}
				text={_str("Send")}
				showPhoneWall={showPhoneWall}
				launchPhoneFlow={openPhoneVerification}
			/>
		</div>
	);
}

BaseIntro.propTypes = {
	onClose: PropTypes.func.isRequired,
	header: PropTypes.string.isRequired,
	subtitle: PropTypes.string,
	children: PropTypes.node.isRequired,
	targetUser: PropTypes.object.isRequired,
	myThumb: PropTypes.string.isRequired,
	onMessageEdit: PropTypes.func.isRequired,
	sendMessage: PropTypes.func.isRequired,
	draft: PropTypes.string,
};

BaseIntro.defaultProps = {
	subtitle: null,
	draft: "",
};

export default BaseIntro;



// WEBPACK FOOTER //
// ./src/apps/messenger/components/Connections/Postmatch/BaseIntro.jsx